import React, { useState } from 'react';
import { todayKST } from '../../utils/date';
import { useIsMobile } from '../../hooks/useIsMobile';
import { AdminMarketerConsultantPc } from './marketer-consultant/AdminMarketerConsultantPc';
import { AdminMarketerConsultantMobile } from './marketer-consultant/AdminMarketerConsultantMobile';
import { MarketerConsultantModals } from './marketer-consultant/MarketerConsultantModals';
import { TAB_ITEMS } from './marketer-consultant/MarketerConsultantTabs';
import { useMarketerConsultantPage } from './marketer-consultant/useMarketerConsultantPage';
import { useAssignmentBoardModel } from './marketer-consultant/useAssignmentBoardModel';
import { useAssignmentActions } from './marketer-consultant/useAssignmentActions';
import { useMonthlyCalculation } from './marketer-consultant/useMonthlyCalculation';
import { useChangeHistory } from './marketer-consultant/useChangeHistory';

// 2026-10-06 UX: [배정 관리](처음) [1:1급여 정산] [상담자배분] 탭
const PAGE_TABS = TAB_ITEMS;

export default function AdminMarketerConsultantPage({
  availableCompanies = null,
  integratedMenuId = null,
  fixedCompanyCode = null,
  fixedCompanyName = null,
  pageTitle = '마케터 1:1 관리',
}) {
  // 데이터·창 상태·저장 처리는 훅 한 곳(2026-10-06 분리) — PC·휴대폰 화면이 같이 쓴다.
  const vm = useMarketerConsultantPage({ availableCompanies, integratedMenuId, fixedCompanyCode, fixedCompanyName });
  const today = todayKST();
  // 보드 계산(숨김·배정 안 된 직원·건수)과 누르는 방식의 배정 동작(상세·마케터 고르기·급여 조건) — 2026-10-06 2단계
  const board = useAssignmentBoardModel({
    marketers: vm.marketers,
    consultants: vm.consultants,
    assignments: vm.assignments,
    today,
    companyCode: vm.activeTab,
    basisMonth: vm.boardMonth,
  });
  const actions = useAssignmentActions({
    assignments: vm.assignments,
    openAdd: vm.openAdd,
    openEdit: vm.openEdit,
    openMove: vm.openMove,
    openEnd: vm.openEnd,
    handleDelete: vm.handleDelete,
  });
  // 1:1급여 정산(정산할 달·넣기/빼기·확정) — 탭 이름의 '확인 N' 숫자를 위해 페이지에서 한 번 불러 둔다(종전에도 화면을 열면 불렀다)
  const calc = useMonthlyCalculation({
    companyCode: vm.activeTab,
    integratedMenuId,
    assignments: vm.assignments,
    onAssignmentsChanged: () => vm.loadData(vm.activeTab),
  });
  // 변경 기록 창(회사 전체 / 배정 하나) — 2026-10-06 5단계
  const history = useChangeHistory({ companyCode: vm.activeTab, integratedMenuId });
  const [tab, setTab] = useState('assign');
  const isMobile = useIsMobile();

  // 정산 탭으로 들어올 때마다 계산을 새로 받아 온다(배정 탭에서 바꾼 담당·기간이 바로 반영되게, 보던 화면은 유지)
  function changeTab(next) {
    setTab(next);
    if (next === 'charge' && next !== tab) calc.reload();
  }

  // PC·휴대폰은 같은 훅·같은 창을 쓰고 그리기만 다르다(768px 기준, 2026-10-06 4단계)
  const view = {
    vm, board, actions, calc, history, today, tab, onTab: changeTab, tabItems: PAGE_TABS, integratedMenuId, pageTitle,
  };

  return (
    <>
      {isMobile ? <AdminMarketerConsultantMobile {...view} /> : <AdminMarketerConsultantPc {...view} />}
      <MarketerConsultantModals vm={vm} board={board} actions={actions} calc={calc} history={history} today={today} integratedMenuId={integratedMenuId} />
    </>
  );
}
